import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface RowWrapperProps {
  isPending?: boolean
}

export const RowWrapper = styled.button<RowWrapperProps>`
  display: grid;
  opacity: ${({ isPending }) => (isPending ? 0.5 : 1)};
  align-items: center;
  gap: ${Spacing.S16};
  column-gap: ${Spacing.S16};
  grid-template-columns: auto 2fr 0.8fr 0.6fr 0.35fr;
  width: 100%;
  padding: ${Spacing.S12};
  border: none;
  border-radius: ${BorderRadius.R12};
  background: none;
  font: inherit;
  text-align: left;
  cursor: ${({ isPending }) => (isPending ? 'default' : 'pointer')};

  ${({ isPending }) =>
    !isPending &&
    `&:hover {
      background-color: ${Color.Grey50};
    }`}
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: ${BorderRadius.R14};
  background-color: ${Color.Grey100};
`

export const RightAlignedColumn = styled.div`
  text-align: right;
`
